<template>
    <div class="overlay">
        <div class="loader-container">
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.overlay {
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    background-color: rgba(253, 253, 253, 0.897);
    z-index: 100;
    top: 0;
    overflow: auto;
}
.loader-container {
    width: fit-content;
    position: absolute;
    top: 35%;
    left: 40%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    .spinner-grow {
        width: 4rem;
        height: 4rem;
    }
}
</style>